export class UsersGroupsIdAddRemoveDto {
  public listUsers: {list: number[]};
  public listGroups: {list: number[]};
}
